module.exports = __webpack_public_path__ + "static/media/logo149.202b1e8a.png";